import {
  Box
} from '@mui/material'

import { useContext } from 'react'

// Context
import { InventoryDataContext, InventoryDispatchContext } from 'src/store/inventory/Store'
import { ItemDataContext } from 'src/store/items/Store'
import { setEquipped, setQuantity } from 'src/store/inventory/actions'
import { setEquippedStats } from 'src/store/stats/actions'
import { NavigationDataContext } from 'src/store/navigation/Store'

// Components
import ItemBlock from 'src/components/common/ItemBlock'
import { type Equipment } from 'src/types'
import { StatsDataContext, StatsDispatchContext } from 'src/store/stats/Store'
import CurrencyBlock from './CurrencyBlock'
import { hideScrollbarX, hideScrollbarY } from 'src/utils/cssStyles'

const container = {
  width: '100%',
  maxHeight: '128px',
  display: 'flex',
  flexDirection: 'row',
  ...hideScrollbarY,
  ...hideScrollbarX
}

const wrapper = {
  maxWidth: '324px',
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '16px'
}

const Bag = () => {
  const { inventory } = useContext(InventoryDataContext)
  const { navigation } = useContext(NavigationDataContext)
  const { items } = useContext(ItemDataContext)
  const { stats } = useContext(StatsDataContext)
  const { dispatchInventory } = useContext(InventoryDispatchContext)
  const { dispatchStats } = useContext(StatsDispatchContext)

  const handleEquip = (itemID: string) => {
    // @ts-expect-error
    const item: Equipment = items[itemID]
    if (item && item.slot) {
      if (inventory.equipped[item.slot].length > 0) {
        // puts current equipment in bag
        setQuantity(dispatchInventory, 'bag', inventory.equipped[item.slot], { '+': 1})
        // takes new item from bag
        setQuantity(dispatchInventory, 'bag', itemID, { '-': 1})
        // equips new item
        setEquipped(dispatchInventory, item.slot, itemID, true)
      } else {
        setQuantity(dispatchInventory, 'bag', itemID, { '-': 1})
        // equips new item
        setEquipped(dispatchInventory, item.slot, itemID, true)
      }
    }
  }

  const handleDiscard = (itemID: string) => {
    setQuantity(dispatchInventory, 'bag', itemID, { '-': 1})
    setQuantity(dispatchInventory, 'loot', itemID, { '+': 1})
    setEquippedStats(dispatchStats, items, inventory)
    // send items to the loot or storage
  }

  const handleStash = (itemID: string) => {
    setQuantity(dispatchInventory, 'bag', itemID, { '-': 1})
    setQuantity(dispatchInventory, 'stash', itemID, { '+': 1})
  }

  const bagSlots = stats.equipped.bag_slots || 2
  let usedBagSlots = 0

  // if an item is equiped, subtract 1 and render the rest
  const ownedItemsCount = Object.keys(inventory.bag).reduce((total, itemID) => total + inventory.bag[itemID], 0)
  const itemIDs = Object.entries(inventory.bag).filter(([itemID, count]) => count > 0 && items[itemID]).map(([itemID]) => itemID)
  
  return (
    <Box sx={container} className="bag">
      <Box sx={wrapper} className='items'>
        <CurrencyBlock
          currencyID='cigs'
        />
        {itemIDs.map((itemID, index) => {
          const itemCount = inventory.bag[itemID]
          const repeatedItemList = new Array(itemCount).fill('')
          return (
            repeatedItemList.map((_, subIndex) => {
              usedBagSlots += 1
              return (
                <ItemBlock
                  key={`used_slot_${index}_${subIndex}`}
                  item={items[itemID]}
                  handleClick={navigation.loot_open ? handleDiscard : navigation.stash_open ? handleStash : handleEquip}
                  color={usedBagSlots > bagSlots ? 'crimson' : 'white'}
                />
              )
            })
          )
        })}
        {
        new Array(bagSlots - ownedItemsCount < 0 ? 0 : bagSlots - ownedItemsCount).fill('').map((_, index) => (
          <ItemBlock
            key={`empty_slot_${index}`}
            handleClick={() => {}}
          />
        ))
        }
       </Box>
    </Box>
  )
}

export default Bag
